var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAudio = function SvgAudio(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.61305 0 4.32387 0.948211 2.63604 2.63604C0.948211 4.32387 0 6.61305 0 9V16C0 17.1 0.9 18 2 18H6V10H2V9C2 5.13 5.13 2 9 2C12.87 2 16 5.13 16 9V10H12V18H16C17.1 18 18 17.1 18 16V9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.3869 0 9 0ZM4 12V16H2V12H4ZM16 16H14V12H16V16Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAudio);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEM2LjYxMzA1IDAgNC4zMjM4NyAwLjk0ODIxMSAyLjYzNjA0IDIuNjM2MDRDMC45NDgyMTEgNC4zMjM4NyAwIDYuNjEzMDUgMCA5VjE2QzAgMTcuMSAwLjkgMTggMiAxOEg2VjEwSDJWOUMyIDUuMTMgNS4xMyAyIDkgMkMxMi44NyAyIDE2IDUuMTMgMTYgOVYxMEgxMlYxOEgxNkMxNy4xIDE4IDE4IDE3LjEgMTggMTZWOUMxOCA2LjYxMzA1IDE3LjA1MTggNC4zMjM4NyAxNS4zNjQgMi42MzYwNEMxMy42NzYxIDAuOTQ4MjExIDExLjM4NjkgMCA5IDBaTTQgMTJWMTZIMlYxMkg0Wk0xNiAxNkgxNFYxMkgxNlYxNloiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg==";